import React from "react";
import MainDashboard from "./Screens/Admin/Dashboard";
import SignIn from "./Screens/Auth/SignIn";
import { MdHome, MdLock, MdOutlineCategory } from "react-icons/md";
import ForgotPassword from "./Screens/Auth/ForgotPassword";
import { LuLayoutDashboard } from "react-icons/lu";
import UserProfile from "Screens/Admin/UserProfile";
import { BiCategoryAlt } from "react-icons/bi";
import { BiPackage } from "react-icons/bi";
import SignUp from "./Screens/Auth/SignUp";
import Staff from "./Screens/Admin/Staff";
import Task from "./Screens/Admin/Task";
import { FaTasks, FaUsers } from "react-icons/fa";
import { HiOutlineDocumentReport } from "react-icons/hi";
import { FaLocationDot } from "react-icons/fa6";
import Report from "Screens/Admin/Report";
import Site from "Screens/Admin/Site";
import Category from "Screens/Admin/Category";

const routes = [
  {
    name: "Dashboard",
    showInSidebar: true,
    layout: "/admin",
    path: "dashboard",
    icon: <LuLayoutDashboard className="h-6 w-6" />,
    component: <MainDashboard />,
    permission: "dashboard",
    clickable: true,
  },
  {
    name: "Staff",
    showInSidebar: true,
    layout: "/admin",
    path: "staff",
    icon: <FaUsers className="h-6 w-6" />,
    component: <Staff />,
    permission: "staff",
    clickable: true,
  },
  {
    name: "Task",
    showInSidebar: true,
    layout: "/admin",
    path: "task",
    icon: <FaTasks className="h-6 w-6" />,
    component: <Task />,
    permission: "tasks",
    clickable: true,
  },
  {
    name: "Category",
    showInSidebar: true,
    layout: "/admin",
    path: "category",
    icon: <MdOutlineCategory className="h-6 w-6" />,
    component: <Category />,
    permission: "staff",
    clickable: true,
  },
  {
    name: "Site",
    showInSidebar: true,
    layout: "/admin",
    path: "sites",
    icon: <FaLocationDot className="h-6 w-6" />,
    component: <Site />,
    permission: "staff",
    clickable: true,
  },
  {
    name: "Report",
    showInSidebar: true,
    layout: "/admin",
    path: "report",
    icon: <HiOutlineDocumentReport className="h-6 w-6" />,
    component: <Report />,
    permission: "tasks",
    clickable: true,
  },
  {
    name: "User Profile",
    showInSidebar: false,
    layout: "/admin",
    path: "user-profile",
    icon: <MdHome className="h-6 w-6" />,
    component: <UserProfile />,
    clickable: true,
  },

  // Auth Routes Below
  {
    name: "Sign In",
    layout: "/auth",
    path: "sign-in",
    icon: <MdLock className="h-6 w-6" />,
    component: <SignIn />,
  },
  {
    name: "Sign Up",
    layout: "/auth",
    path: "sign-up",
    icon: <MdLock className="h-6 w-6" />,
    component: <SignUp />,
  },
  {
    name: "Forgot Password",
    layout: "/auth",
    path: "forgot-password",
    icon: <MdLock className="h-6 w-6" />,
    component: <ForgotPassword />,
  },
];

export default routes;
